import React from "react";
import "./AppCard.css";

const AppCard = ({ title, color, permissions, onClick }) => {
  return (
    <div
      className="app-card"
      style={{
        borderLeftColor: color,
        "--app-card-color": color, // Pass app color as CSS variable
        "--card-accent": color,
      }}
      onClick={onClick}
    >
      {/* <h3 style={{ color }}>{title}</h3>
       */}
      <h3
        style={{
          color: color,
          fontSize: "1.4rem",
          fontWeight: 800,
          letterSpacing: "0.3px",
          marginBottom: "8px",
        }}
      >
        {title}
      </h3>

      <div className="permissions">
        {permissions.includes("all") ? (
          <span className="permission-tag full-access">Full Access</span>
        ) : (
          permissions.map((perm, index) => (
            <span key={index} className="permission-tag">
              {perm}
            </span>
          ))
        )}
      </div>
      <div className="click-hint">Click to open →</div>
    </div>
  );
};

export default AppCard;
